/**
 * Panel. DESIGN.md §Cards: a surface card, 20px radius, 1px divider edge, 24px padding
 * (16px under 820px), flat (no shadow). A title makes it a labelled region.
 */
import React, { useId } from "react";
import { cn } from "./cn";

export function Panel({
  as: Component = "section",
  title,
  className,
  children,
  ...props
}) {
  const id = useId();
  return (
    <Component
      aria-labelledby={title ? id : undefined}
      className={cn(
        "tw-min-w-0 tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-bg-surface tw-p-6 tw-text-text max-rail:tw-p-4",
        className,
      )}
      {...props}
    >
      {title && (
        <h2
          id={id}
          className="tw-m-0 tw-mb-4 tw-text-lg tw-font-bold tw-text-text"
        >
          {title}
        </h2>
      )}
      {children}
    </Component>
  );
}
